export default "__VITE_ASSET__CavDyaYg__"